export const PANEL_TYPES = {
    EDIT_USER: 'edit_user_sliding_panel',
    EDIT_TASK: 'edit_task_sliding_panel',
    CREATE_TASK: 'create_task_sliding_panel',
    EDIT_PROJECT: 'edit_project_sliding_panel',
    EDIT_CUSTOMER: 'edit_customer_sliding_panel',
    TEAM_ASSIGNMENT: 'team_assignment_sliding_panel',
    WORK_ASSIGNMENTS_PANEL: 'work_assignments_sliding_panel',
    WORK_ASSIGNMENTS_EDITOR: 'work_assignments_editor_sliding_panel',
    MANAGEMENT_ASSIGNMENTS_PANEL: 'management_assignments_panel_sliding_panel',
    MANAGEMENT_ASSIGNMENTS_EDITOR: 'management_assignments_editor_sliding_panel',
    HOLIDAY_LIST_PANEL: 'holiday_list_panel',
    IMPORT_HOLIDAYS_PANEL: 'import_holidays_sliding_panel',
}

export const SHOW_ANIMATION_CLASSES = {
    SLIDE_LEFT: "anim-show-slide-left",
    SLIDE_UP: "anim-show-slide-up",
    SLIDE_RIGHT: "anim-show-slide-right",
}

export const HIDE_ANIMATION_CLASSES = {
    SLIDE_LEFT: "anim-hide-slide-left",
    SLIDE_UP: "anim-hide-slide-up",
    SLIDE_RIGHT: "anim-hide-slide-right",
}



// WEBPACK FOOTER //
// ./web/js/panels/constants.js